import { useMutation, useQuery } from "@tanstack/react-query";
import postApiData from "../../services/postApiServices";
import { getOrPostSensors, getReports,reportDownLoad } from "../../constants/api-end-pionts";
import { useState } from "react";
import getApiServices from "../../services/getApiService";
import { useMemo } from "react";

interface CustomStyle {
  control: (provided: Record<string, any>) => Record<string, any>;
  placeholder: (provided: Record<string, any>) => Record<string, any>;
  singleValue: (provided: Record<string, any>) => Record<string, any>;
  menu: (provided: Record<string, any>) => Record<string, any>;
  option: (
    provided: Record<string, any>,
    state: { isSelected: boolean }
  ) => Record<string, any>;
  input: (provided: Record<string, any>) => Record<string, any>;
}

const useReports = () => {
  const [deviceId, setDeviceId] = useState("");
  const [startTime, setStartTime] = useState("");
  const [isoStartTime, setIsoStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [isoEndTime, setIsoEndTime] = useState("");
  const [isCriticalReport, setIsCriticalReport] = useState(false);
  const [downloadingReport, setDownloadingReport] = useState(false);
  const [reportError, setReportError] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [firstPage, setFirstPage] = useState();
  const [lastPage, setLastPage] = useState();
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [currentPage, setCurrentPage] = useState(0);


  const customeStyle: CustomStyle = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "", // Blue background
      borderRadius: "8px",
      boxShadow: "none",
      outline: "none",
      padding: "5px",
      border: "1px solid #1E3A8A",
      color: "white",
      "&:hover": { borderColor: "#2563EB" },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "white", // Grayish placeholder text
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "white", // Selected text color
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#15264A",
      borderRadius: "8px",
      overflow: "hidden",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "" : "",
      color: state.isSelected ? "white" : "#E5E7EB",
      padding: "10px",
      "&:hover": { backgroundColor: "#2563EB", color: "white" },
    }),
    input: (provided) => ({
      ...provided,
      color: "white",
      boxShadow: "none",
      outline: "none",
      caretColor: "white",
    }),
  };

  const { data: sensorListData } = getSensorList();

  const options = useMemo(() => {
    if (sensorListData?.content?.length > 0) {
      return sensorListData?.content?.map((sensor: any) => ({
        value: sensor.id,
        label: sensor.name,
      }));
    }
    return [{ value: "", label: "No sensors found" }];
  }, [sensorListData]);

  const handleChange = (selectedOption: any) => {
    console.log("Selected Option : ", selectedOption);
    setDeviceId(selectedOption.label);
  };

  const handleStartTimeChange = (e: any) => {
    const localDateTime = e.target.value; // Get the selected datetime string
    const [datePart, timePart] = localDateTime.split("T"); // Split date and time

    // Construct an ISODate without converting to UTC
    const isoDate = `${datePart}T${timePart}:00.000Z`; // Keep the exact local time

    console.log("Normal Date:", localDateTime);
    console.log("ISODate (Fixed):", isoDate);

    setStartTime(localDateTime);
    setIsoStartTime(isoDate);
  };

  const handleEndTimeChange = (e: any) => {
    const localDateTime = e.target.value; // Get the selected datetime string
    const [datePart, timePart] = localDateTime.split("T"); // Split date and time

    // Construct an ISODate without converting to UTC
    const isoDate = `${datePart}T${timePart}:00.000Z`;
    setEndTime(localDateTime);
    setIsoEndTime(isoDate);
  };

  function getSensorList() {
    const url = `${getOrPostSensors}`;

    return useQuery({
      queryKey: ["sensorsList"],
      refetchOnWindowFocus: false,
      queryFn: () => getApiServices(url),
    });
  }

  function callReportApi() {
    const url = `${getReports}?page=${currentPage}&size=${pageSize}`;

    const body = {
      deviceId: `${deviceId}`,
      startTime: `${isoStartTime}`,
      endTime: `${isoEndTime}`,
      isCriticalReport: isCriticalReport,
    };

    return useMutation({
      mutationKey: ["reports", currentPage, pageSize],
      mutationFn: () => postApiData(url, body),
    });
  }

  function downloadReport() {
    const body = {
      deviceId: `${deviceId}`,
      startTime: `${isoStartTime}`,
      endTime: `${isoEndTime}`,
      isCriticalReport: isCriticalReport,
    };

    return useMutation({
      mutationKey: ["downloadReport"],
      mutationFn: () => postApiData(reportDownLoad, body, { responseType: "blob" }),
      onSuccess: (response: any) => {
        // Create a blob from the response data
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);
        
        // Create a temporary link element
        const link = document.createElement('a');
        link.href = url;
        
        // Try to get filename from content-disposition header or use default
        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'report.xlsx';
        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
            if (fileNameMatch && fileNameMatch.length > 1) {
                fileName = fileNameMatch[1];
            }
        }
        
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        
        // Cleanup
        link.parentNode?.removeChild(link);
        window.URL.revokeObjectURL(url);
      },
      onError: (error) => {
        console.error("Download error:", error);
      }
    });
  }


  console.log("Sensor List Data: ", sensorListData);

  return {
    callReportApi,
    options,
    handleChange,
    customeStyle,
    startTime,
    handleStartTimeChange,
    endTime,
    handleEndTimeChange,
    isCriticalReport,
    setIsCriticalReport,
    downloadingReport,
    reportError,
    pageSize,
    setPageSize,
    currentPage,
    setCurrentPage,
    firstPage,
    lastPage,
    totalPages,
    setDownloadingReport,
    setReportError,
    setReportData,
    setFirstPage,
    setLastPage,
    setTotalPages,
    reportData,
    sensorListData,
    downloadReport
  };
};

export default useReports;
